import { useState } from 'react';
import type { Deal } from '../lib/flip';
import { go } from '../state/useHashRoute';
import { useDraft } from '../state/useDraft';
import { useStore } from '../state/store';
import { DealForm } from './DealForm';
import { ResultsPanel } from './ResultsPanel';

interface Draft {
  title: string;
  deal: Deal;
}

const isDraft = (v: unknown): v is Draft =>
  typeof v === 'object' && v !== null && typeof (v as Draft).title === 'string' && typeof (v as Draft).deal === 'object' && (v as Draft).deal !== null;

export function CalculatorPage() {
  const { data, addCar } = useStore();
  const [draft, setDraft, clear] = useDraft<Draft>(
    'car-flip-planner:draft',
    () => ({ title: '', deal: structuredClone(data.settings.defaults) }),
    isDraft,
  );
  const [error, setError] = useState('');

  const save = () => {
    if (!draft.title.trim()) {
      setError('Give the car a name first, for example "2011 Fiesta 1.2".');
      return;
    }
    const car = addCar(draft.title, draft.deal);
    clear();
    go(`/car/${car.id}`);
  };

  return (
    <div className="page two-col">
      <div>
        <h1>Deal calculator</h1>
        <p className="lede">Type in what you expect to pay and sell for. The result updates as you type, and your entries are kept if you leave the page.</p>
        <div className="field">
          <label htmlFor="car-title">Car</label>
          <input id="car-title" type="text" value={draft.title} placeholder="e.g. 2011 Ford Fiesta 1.2" onChange={(e) => { setError(''); setDraft({ ...draft, title: e.target.value }); }} />
        </div>
        <DealForm deal={draft.deal} onChange={(deal) => setDraft({ ...draft, deal })} />
        {error && <p className="error" role="alert">{error}</p>}
        <div className="actions">
          <button type="button" className="btn primary" onClick={save}>Save to my cars</button>
          <button type="button" className="btn" onClick={() => { clear(); setError(''); }}>Start again</button>
        </div>
      </div>
      <ResultsPanel deal={draft.deal} settings={data.settings} />
    </div>
  );
}

